import { responsiveSearch } from './responsive-search';
import { responsiveSearchDesktop } from './responsive-search-desktop';
import { responsiveSearchMobile } from './responsive-search-mobile';

export const responsiveSearchAdTemplates = [
  responsiveSearch,
  responsiveSearchDesktop,
  responsiveSearchMobile,
];
